import { GdsServiceVipSubType, OrderAdditionalServiceGdsServiceServiceType } from '@websky/graphql';
export const isFareLockService = (service) => {
    return service.isPriceFreeze || 'freezeUntil' in service;
};
export const isRefundOptionService = (service) => {
    return (service.type === OrderAdditionalServiceGdsServiceServiceType.Vip &&
        service.subType === GdsServiceVipSubType.RefundableTicket);
};
export const getRefundOptionService = (order) => {
    var _a;
    return (_a = order === null || order === void 0 ? void 0 : order.additionalServices.gdsServices) === null || _a === void 0 ? void 0 : _a.services.find(isRefundOptionService);
};
export const getIsRefundOptionSelected = (order) => {
    var _a;
    const refundOptionService = getRefundOptionService(order);
    return (_a = order === null || order === void 0 ? void 0 : order.travellers) === null || _a === void 0 ? void 0 : _a.some(traveller => { var _a, _b, _c; return (_c = (_b = (_a = traveller === null || traveller === void 0 ? void 0 : traveller.services) === null || _a === void 0 ? void 0 : _a.gdsServices) === null || _b === void 0 ? void 0 : _b.services) === null || _c === void 0 ? void 0 : _c.some(service => (service === null || service === void 0 ? void 0 : service.serviceId) === (refundOptionService === null || refundOptionService === void 0 ? void 0 : refundOptionService.id)); });
};
export const getParamsForSaveOrderServicesMutation = (order, optionService, action) => {
    const travellerServices = [];
    order.travellers.forEach(traveller => {
        const gdsServices = {};
        const allowedPassengers = Array.prototype.concat.apply([], optionService === null || optionService === void 0 ? void 0 : optionService.allowedPassengers);
        if (!allowedPassengers.includes(traveller.id)) {
            return;
        }
        if (action === 'add') {
            gdsServices.addServices = [
                {
                    count: 1,
                    segmentIds: Array.prototype.concat.apply([], optionService.allowedSegments),
                    serviceId: optionService.id
                }
            ];
        }
        else {
            gdsServices.setServices = [
                {
                    count: 0,
                    segmentIds: Array.prototype.concat.apply([], optionService.allowedSegments),
                    serviceId: optionService.id
                }
            ];
        }
        travellerServices.push({
            travellerId: traveller.id,
            gdsServices
        });
    });
    return travellerServices;
};
